(ns practitest.frontend.common-old-fe.i18n)

(defonce data (atom nil))

(defn initialize [dictionary]
  (reset! data dictionary))

;; if there is no value for given `k`, just return it so we'll notice that something is missing
(defn t [k]
  (if (contains? @data k)
    (get @data k)
    k))
